<template>
  <div class="template-variable-inserter d-flex align-items-center gap-4 mb-8 flex-wrap">
    <span class="text-xs fw-bold text-uppercase text-muted">{{ label }}</span>
    <button
      v-for="variable in variables"
      :key="variable.token"
      type="button"
      class="btn btn-outline-secondary btn-sm template-variable-btn"
      :title="variable.description"
      @click="insertVariable(variable.token)"
    >
      {{ variable.label }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import { TEMPLATE_VARIABLES } from "@/composables/useTemplateVariables";

defineProps<{
  label?: string;
}>();

const emit = defineEmits<{
  (e: "insert", token: string): void;
}>();

const variables = TEMPLATE_VARIABLES;

const insertVariable = (token: string) => {
  emit("insert", token);
};
</script>

<style scoped>
.template-variable-btn {
  font-size: 0.7rem !important;
  padding: 0.2rem 0.5rem !important;
  border-radius: 4px !important;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.template-variable-btn:hover {
  background-color: #e61275 !important;
  border-color: #e61275 !important;
  color: #ffffff !important;
}
</style>
